var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"run-detail"},[_c('v-card',[_c('v-card-title',[_c('div',[_vm._v("Результаты обхода")])]),_c('v-card-text',[_c('run-detail',{attrs:{"runId":_vm.$route.params.id}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }